module.exports = __webpack_public_path__ + "img/tarjeta_informacion_nuevo_reglamento_circulacion.08c42178.png";